import { api } from '../utils'

export const createEvent = params =>
  api.post(`/events`, params).then(res => res?.data)
